import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AlertRuleCreateOrUpdateUI from './AlertRuleCreateOrUpdateUI.js'

class AlertRuleCreateOrUpdateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // priority
      priority: this.props.alertRule ? this.props.alertRule.priority : 'p1',
      priorityList: null,
      // dueInDays
      dueInDays: this.props.alertRule ? this.props.alertRule.dueInDaysCode : 'd7',
      dueInDaysList: null,
      // duePastDays
      duePastDays: this.props.alertRule ? this.props.alertRule.duePastDaysCode : 'd3',
      duePastDaysList: null,
      // repeatIntervalDays
      repeatIntervalDays: this.props.alertRule ? this.props.alertRule.repeatIntervalDaysCode : 'd0',
      repeatIntervalDaysList: null,
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <AlertRuleCreateOrUpdateUI
        context={this.props.context}
        messageList={this.props.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // priority
        priority={this.state.priority}
        priorityList={this.state.priorityList}
        onPriorityChange={(event) => {this.setState({priority: event.target.value})}}
        // dueInDays
        dueInDays={this.state.dueInDays}
        dueInDaysList={this.state.dueInDaysList}
        onDueInDaysChange={(event) => {this.setState({dueInDays: event.target.value})}}
        // duePastDays
        duePastDays={this.state.duePastDays}
        duePastDaysList={this.state.duePastDaysList}
        onDuePastDaysChange={(event) => {this.setState({duePastDays: event.target.value})}}
        // repeatIntervalDays
        repeatIntervalDays={this.state.repeatIntervalDays}
        repeatIntervalDaysList={this.state.repeatIntervalDaysList}
        onRepeatIntervalDaysChange={(event) => {this.setState({repeatIntervalDays: event.target.value})}}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelCreateClick={this.props.onCancelCreateClick}
      />
    )
  }

  UNSAFE_componentWillMount() {
    let context = this.props.context
    this.getTaskPriorities(context)
    this.getDueInDays(context)
    this.getDuePastDays(context)
    this.getRepeatIntervalDays(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: null,
      submitted: true
    })

    let context = this.props.context

    if (this.props.alertRule) {
      RestApiUtils.put(context,
        `/api/projects/${this.props.project.projectId}/alerts/${this.props.alertRule.alertRuleId}`,
        this.onSubmitCallback, {
          priority: this.state.priority,
          dueInDays: this.state.dueInDays,
          duePastDays: this.state.duePastDays,
          repeatIntervalDays: this.state.repeatIntervalDays,
        }
      )
    }
    else {
      RestApiUtils.post(context,
        `/api/projects/${this.props.project.projectId}/alerts`,
        this.onSubmitCallback, {
          priority: this.state.priority,
          dueInDays: this.state.dueInDays,
          duePastDays: this.state.duePastDays,
          repeatIntervalDays: this.state.repeatIntervalDays,
        }
      )
    }
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})

    if (this.state.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.AlertRules(this.props.project.projectId))
      setTimeout(() => {
        this.props.history.push(`/projects/${this.props.project.projectId}/alerts`)
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  getTaskPriorities(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/task-priorities`,
      cacheKey: CacheKeys.TaskPriorities(),
      callback: this.getTaskPrioritiesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getTaskPrioritiesCallback = (response) => {
    let priorityList = Object.keys(response.taskPriorityMap)
      .map(key => ({key: key, value: response.taskPriorityMap[key]}))
    this.setState({priorityList: priorityList})
  }

  getDueInDays(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/alert-due-in-days`,
      cacheKey: CacheKeys.AlertDueInDays(),
      callback: this.getDueInDaysCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getDueInDaysCallback = (response) => {
    let dueInDaysList = Object.keys(response.alertDueInDaysMap)
      .map(key => ({key: key, value: response.alertDueInDaysMap[key]}))
    this.setState({dueInDaysList: dueInDaysList})
  }

  getDuePastDays(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/alert-due-past-days`,
      cacheKey: CacheKeys.AlertDuePastDays(),
      callback: this.getDuePastDaysCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getDuePastDaysCallback = (response) => {
    let duePastDaysList = Object.keys(response.alertDuePastDaysMap)
      .map(key => ({key: key, value: response.alertDuePastDaysMap[key]}))
    this.setState({duePastDaysList: duePastDaysList})
  }

  getRepeatIntervalDays(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/alert-repeat-interval-days`,
      cacheKey: CacheKeys.AlertRepeatIntervalDays(),
      callback: this.getRepeatIntervalDaysCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getRepeatIntervalDaysCallback = (response) => {
    let repeatIntervalDaysList = Object.keys(response.alertRepeatIntervalDaysMap)
      .map(key => ({key: key, value: response.alertRepeatIntervalDaysMap[key]}))
    this.setState({repeatIntervalDaysList: repeatIntervalDaysList})
  }
}

export default withRouter(AlertRuleCreateOrUpdateSF)
